import React, { useEffect, useRef, useState } from 'react'
import './admin-add-product.css'
import ToastNotification, { showToast } from '../../components/toasts/ToastNotification';
import { ClipLoader } from "react-spinners";
import { Link, useNavigate } from 'react-router-dom';
import { addNewProduct, addPackageImages } from '../../api/product.api';
import { getProductTypeObject } from '../../utils';
import { TiDelete } from "react-icons/ti";


export const AdminAddProduct = () => {
    const [images, setImages] = useState([]);
    const [extraImages, setExtraImages] = useState([]);// Store image files
    const [previews, setPreviews] = useState([]); // Store image previews
    const [selectedType, setSelectedType] = useState("game_account");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [price, setPrice] = useState(0);
    const [stock, setStock] = useState(0);
    const [displayPrice, setDisplayPrice] = useState("");
    const [productName, setProductName] = useState("");
    const [productDescription, setProductDescription] = useState("THÔNG TIN TÀI KHOẢN: \n \n Các tài khoản đã được Admin kiểm tra cẩn thận, không liên kết Game Center hay Google Play \n Tài khoản có nguồn gốc rõ ràng, nói không với những acc nạp coin lậu \n \n CHÍNH SÁCH BẢO HÀNH: \n \n Bảo hành khi khách hàng gặp lỗi không đăng nhập được tài khoản và mật khẩu \n Hỗ trợ tất cả những vấn đề liên quan đến tài khoản đã mua");
    const [isValuable, setIsValuable] = useState(false);

    const [amount, setAmount] = useState("");
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const fileInputRef = useRef(null);

    useEffect(() => {
        document.title = 'Admin - Thêm sản phẩm';
    }, []);

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        // Limit to 5 images
        if (files.length + images.length > 5) {
            showToast("Chỉ được tải lên tối đa 5 ảnh", "error");
            return;
        }

        const newImages = [...images, ...files].slice(0, 5);
        const newPreviews = newImages.map((file) => URL.createObjectURL(file));

        setImages(newImages);
        setPreviews(newPreviews);
    };

    const handleExtraImageChange = (event, index) => {
        const file = event.target.files[0];

        setExtraImages(prev => {
            const updated = [...prev];

            if (file) {
                // Replace or insert at index
                updated[index] = file;
            } else {
                // Remove image at index if user cancels
                updated.splice(index, 1);
            }

            return updated;
        });
    };
    

    const handleRemoveImage = (index) => {
        const newImages = images.filter((_, i) => i !== index);
        const newPreviews = previews.filter((_, i) => i !== index);
        setImages(newImages);
        setPreviews(newPreviews);
    };

    const handleImgClick = (event) => {
        fileInputRef.current.click();
    };

    const handleFormatPrice = (price) => {
        const numericValue = price.replace(/\D/g, "");

        if (numericValue === "") {
            setPrice("");
            setDisplayPrice("");
            return;
        }

        // Convert to number and format
        const formattedPrice = Number(numericValue).toLocaleString();

        setPrice(numericValue);
        setDisplayPrice(formattedPrice);
    }

    useEffect(() => {
        const num = Number(amount);
        if (num > 0) {
            setFormData(() =>
                Array.from({ length: num }, () => getProductTypeObject(selectedType))
            );
        } else {
            setFormData([]);
            setExtraImages([]);
        }
    }, [amount, selectedType]);  // Depend on selectedType



    const handleInputChange = (index, field, value) => {
        setFormData((prevData) =>
            prevData.map((item, i) => (i === index ? { ...item, [field]: value } : item))
        );
    };

    const handleAddProduct = async () => {
        setLoading(true);
        if (!productName || !selectedType || !selectedStatus || !stock) {
            showToast("Bạn phải cung cấp đầy đủ thông tin");
            setLoading(false);
            return;
        }
        
        if (!validateInputs()) {
            showToast("Vui lòng điền đầy đủ thông tin tài khoản", "error");
            setLoading(false);
            return;
        }

        if (images.length === 0) {
            showToast("Bạn phải tải lên ít nhất 1 ảnh", "error");
            setLoading(false);
            return;
        }

        if (selectedType === 'topup_package' && extraImages.length < formData.length) {
            showToast("Bạn phải tên lên đủ ảnh cho gói nạp", "error");
            setLoading(false);
            return;
        }

        try {
            let response = null;
            response = await addNewProduct(
                images,
                productName,
                productDescription,
                selectedType,
                "Mobile Game",
                selectedStatus,
                stock,
                formData,
                price,
                isValuable
            );

            if (response?.success) {

                if (selectedType === 'topup_package') {
                    await addPackageImages(extraImages, response.data.product?.productId);
                }
                
                showToast("Thêm sản phẩm thành công", "success");
                resetForm();
            }
        }
        catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);

        }
    }

    const resetForm = () => {
        setProductName("");
        setSelectedType("game_account");
        setSelectedStatus("");
        setStock(0);
        setPrice(0);
        setDisplayPrice("");
        setAmount("");
        setFormData([]);
        setImages([]);
        setPreviews([]);
        setExtraImages([]);
        setIsValuable(false);
    };

    const validateInputs = () => {
        const newErrors = formData.map((item) => {
            let error = {};
            if ((selectedType === 'utility_account' ||
                selectedType === 'game_account' || 
                selectedType === 'gift_card') && !isValuable) {
                if (!item.username) error.username = "Username is required.";
                if (!item.password) error.password = "Password is required.";
            }
            else if (selectedType === 'topup_package') {
                if (!item.name) error.username = "Username is required.";
                if (!item.price) error.password = "Password is required.";
            }
            return error;
        });
        return newErrors.every((error) => Object.keys(error).length === 0);
    };

    return (
        <section className='admin-add-product-page'>
            <ToastNotification />
            <div className='admin-add-product-shell'>
            <header className='admin-add-product-head'>
                <div>
                    <p className='admin-add-product-breadcrumb'>
                        <Link to='/super-admin/products'>Quản trị / Sản phẩm</Link> / Thêm sản phẩm
                    </p>
                    <h1 className='admin-add-product-title'>Tạo sản phẩm mới</h1>
                </div>
                <div className='admin-add-product-actions'>
                    <button
                        type='button'
                        className='admin-add-product-btn admin-add-product-btn-ghost'
                        onClick={() => navigate('/super-admin/products')}
                    >
                        Hủy
                    </button>
                    <button
                        type='button'
                        onClick={handleAddProduct}
                        disabled={loading}
                        className='admin-add-product-btn admin-add-product-btn-primary'
                    >
                        {loading ? <ClipLoader color='#fff' size={18} /> : "Lưu sản phẩm"}
                    </button>
                </div>
            </header>

            <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
            />

            <div className='admin-add-product-layout'>
                <section className='admin-add-product-card'>
                    <h3 className='admin-add-product-card-title'>Thông tin cơ bản</h3>
                    <div className='admin-add-product-field'>
                        <label>Tên sản phẩm</label>
                        <input
                            value={productName}
                            required
                            className='admin-add-product-input'
                            onChange={(e) => setProductName(e.target.value)}
                        />
                    </div>
                    <div className='admin-add-product-field'>
                        <label>Mô tả sản phẩm</label>
                        <textarea
                            value={productDescription}
                            required
                            className='admin-add-product-textarea'
                            onChange={(e) => setProductDescription(e.target.value)}
                        />
                    </div>
                </section>

                <section className='admin-add-product-card'>
                    <h3 className='admin-add-product-card-title'>Ảnh sản phẩm</h3>
                    <button type='button' className='admin-add-product-upload-trigger' onClick={handleImgClick}>
                        Chọn tối đa 5 ảnh
                    </button>
                    <p className='admin-add-product-upload-note'>Ảnh mới sẽ hiển thị ngay bên dưới.</p>
                    {previews.length > 0 && (
                        <div className="admin-add-product-preview-grid">
                            {previews.map((src, index) => (
                                <div key={index} className="admin-add-product-preview-item">
                                    <img src={src} alt={`Preview ${index + 1}`} className="admin-add-product-preview-image" />
                                    <button type='button' className="admin-add-product-preview-remove" onClick={() => handleRemoveImage(index)}>
                                        <TiDelete />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </section>

                <section className='admin-add-product-card'>
                    <h3 className='admin-add-product-card-title'>Phân loại</h3>
                    <div className='admin-add-product-field'>
                        <label>Loại sản phẩm</label>
                        <select
                            className="admin-add-product-select"
                            value={selectedType}
                            onChange={(e) => {
                                setSelectedType(e.target.value);
                                setAmount(0);
                            }}
                        >
                            <option value="topup_package">Gói nạp</option>
                            <option value="game_account">Tài khoản game</option>
                            <option value="utility_account">Tài khoản tiện ích</option>
                            <option value="gift_card">Gift Card</option>
                        </select>
                    </div>

                    {selectedType !== 'topup_package' && (
                        <>
                            <div className='admin-add-product-field-row'>
                                <div className='admin-add-product-field'>
                                    <label>Giá</label>
                                    <input
                                        inputMode="numeric"
                                        onChange={(e) => handleFormatPrice(e.target.value)}
                                        value={displayPrice}
                                        className='admin-add-product-input'
                                        required
                                    />
                                </div>
                                <div className='admin-add-product-field'>
                                    <label>Tiền tệ</label>
                                    <input className='admin-add-product-input' placeholder='đ' disabled />
                                </div>
                            </div>
                            {selectedType !== 'gift_card' && (
                                <label className='admin-add-product-checkbox-row'>
                                    <input
                                        checked={isValuable}
                                        onChange={() => setIsValuable(!isValuable)}
                                        className='admin-add-product-checkbox'
                                        type='checkbox'
                                    />
                                    <span>Up thông tin thủ công</span>
                                </label>
                            )}
                        </>
                    )}
                </section>

                {(selectedType === "utility_account" ||
                    selectedType === "game_account" ||
                    selectedType === 'gift_card'
                ) && (
                    <section className='admin-add-product-card'>
                        <h3 className='admin-add-product-card-title'>Thêm tài khoản</h3>
                        <input
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            type='number'
                            className='admin-add-product-input'
                            placeholder='Nhập số lượng tài khoản'
                        />
                        <div className='admin-add-product-dynamic-list'>
                            {formData.map((item, index) => (
                                <div key={index} className='admin-add-product-dynamic-item'>
                                    <p className='admin-add-product-dynamic-title'>Tài khoản {index + 1}</p>
                                    <div className='admin-add-product-dynamic-row'>
                                        <input
                                            onChange={(e) => handleInputChange(index, "username", e.target.value)}
                                            type='text'
                                            value={item.username}
                                            className='admin-add-product-input'
                                            placeholder='Tài khoản'
                                        />
                                        <input
                                            onChange={(e) => handleInputChange(index, "password", e.target.value)}
                                            type='text'
                                            value={item.password}
                                            className='admin-add-product-input'
                                            placeholder='Mật khẩu'
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                )}

                {selectedType === "topup_package" && (
                    <section className='admin-add-product-card'>
                        <h3 className='admin-add-product-card-title'>Thêm gói nạp</h3>
                        <input
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            type='number'
                            className='admin-add-product-input'
                            placeholder='Nhập số lượng gói nạp'
                        />
                        <div className='admin-add-product-dynamic-list'>
                            {formData.map((item, index) => (
                                <div key={index} className='admin-add-product-dynamic-item'>
                                    <p className='admin-add-product-dynamic-title'>Gói nạp {index + 1}</p>
                                    <div className='admin-add-product-dynamic-row'>
                                        <input
                                            onChange={(e) => handleInputChange(index, "name", e.target.value)}
                                            type='text'
                                            value={item.name}
                                            className='admin-add-product-input'
                                            placeholder='Tên gói nạp'
                                        />
                                        <input
                                            onChange={(e) => handleInputChange(index, "price", Number(e.target.value.replace(/\D/g, '')))}
                                            value={item.price ? item.price.toLocaleString('vi-VN') : 0}
                                            className='admin-add-product-input'
                                            placeholder='Giá'
                                        />
                                    </div>
                                    <input
                                        type='file'
                                        accept='image/*'
                                        className='admin-add-product-file-input'
                                        onChange={(e) => handleExtraImageChange(e, index)}
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                )}

                <section className='admin-add-product-card'>
                    <h3 className='admin-add-product-card-title'>Trạng thái và tồn kho</h3>
                    <div className='admin-add-product-field'>
                        <label>Trạng thái sản phẩm</label>
                        <select
                            className="admin-add-product-select"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="" disabled>Chọn</option>
                            <option value="active">Active (hiển thị)</option>
                            <option value="inactive">Inactive (không hiển thị)</option>
                        </select>
                    </div>
                    <div className='admin-add-product-field'>
                        <label>Tồn kho</label>
                        <input
                            value={stock}
                            placeholder='0'
                            type='number'
                            inputMode="numeric"
                            onChange={(e) => setStock(Number(e.target.value.replace(/\D/g, '')))}
                            className='admin-add-product-input'
                            required
                        />
                    </div>
                </section>
            </div>
            </div>
        </section>
    )
}
